export const mapStrategies = (serverStrategies) => {
  let newStrategies = serverStrategies.map(s => {
    return {
      id: s.ograsTreatmentID,
      name: s.productName,
      weeds: s.listofProductEffectOnOgras,
      info: s.moreInfo,
      strategy: s.strategy,
      lantmannensStrategy: s.lantmannensStrategy,
      dosage: s.dosage,
      groupname: s.ograsTreatmentGroupName,
      waitingDays: s.waitingDays,
      areaOfUse: s.areaOfUse
    };
  });
  return newStrategies;
}

export const mapTreatmentGroups = (serverTreatmentGroups) => {
  let newTreatmentGroups = serverTreatmentGroups.map(s => {
    return {
      id: s.ograsTreatmentID,
      name: s.productName,
      weeds: s.listofProductEffectOnOgras,
      info: s.moreInfo,
      strategy: s.strategy,
      lantmannensStrategy: s.lantmannensStrategy,
      dosage: s.dosage,
      groupname: s.ograsTreatmentGroupName,
      waitingDays: s.waitingDays,
      areaOfUse: s.areaOfUse
    };
  });
  return newTreatmentGroups;
}

export const mapCompareStrategies = (transposedCompare) => {
  return {
    dosage:transposedCompare.dosage,
    effectOnWeeds:transposedCompare.listofProductEffectOnOgras,
    comments:transposedCompare.moreInfo,
    weedCategory:transposedCompare.ograsTreatmentGroupName,
    ids:transposedCompare.productID,
    names:transposedCompare.productName,
    usageAreas:transposedCompare.areaOfUse,
    waitingDays:transposedCompare.waitingDays
  }
}
